"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideButtonType = void 0;
var GuideButtonType;
(function (GuideButtonType) {
    // GAMES
    GuideButtonType["GAMES_DASHBOARD"] = "GAMES_DASHBOARD";
    GuideButtonType["GAME_DESIGN"] = "GAME_DESIGN";
    GuideButtonType["GAME_SETTINGS"] = "GAME_SETTINGS";
    GuideButtonType["USER_BASE"] = "USER_BASE";
    GuideButtonType["MANAGE_WINNERS"] = "MANAGE_WINNERS";
    // GAME CENTER
    GuideButtonType["GAME_CENTER_DASHBOARD"] = "GAME_CENTER_DASHBOARD";
    GuideButtonType["GENERAL_SETTINGS"] = "GENERAL_SETTINGS";
    GuideButtonType["MODULES"] = "MODULES";
    GuideButtonType["GAME_CENTER_USER_BASE"] = "GAME_CENTER_USER_BASE";
    GuideButtonType["REWARDS_DATA"] = "REWARDS_DATA";
    // GAMIFICATION
    GuideButtonType["GAMIFICATION_DASHBOARD"] = "GAMIFICATION_DASHBOARD";
    GuideButtonType["ATTEMPTS_UNLOCK"] = "ATTEMPTS_UNLOCK";
    GuideButtonType["ADVENTURE_MODE"] = "ADVENTURE_MODE";
    GuideButtonType["COINS_DISTRIBUTION"] = "COINS_DISTRIBUTION";
    GuideButtonType["UNLOCK_REWARDS"] = "UNLOCK_REWARDS";
    GuideButtonType["GAMIFICATION_ANALYTICS"] = "GAMIFICATION_ANALYTICS";
    // USER BASE
    GuideButtonType["USER_BASE_DASHBOARD"] = "USER_BASE_DASHBOARD";
    GuideButtonType["CREATE_EMAIL"] = "CREATE_EMAIL";
    // ACCOUNT PAGES
    GuideButtonType["PROFILE"] = "PROFILE";
    GuideButtonType["MY_ORGANIZATION"] = "MY_ORGANIZATION";
    GuideButtonType["LICENSE"] = "LICENSE";
    GuideButtonType["DOCUMENT_AND_AGREEMENTS"] = "DOCUMENT_AND_AGREEMENTS";
    // MANAGE USER
    GuideButtonType["MANAGE_USER_LIST"] = "MANAGE_USER_LIST";
    GuideButtonType["ADD_USER"] = "ADD_USER";
    GuideButtonType["EDIT_USER"] = "EDIT_USER";
    // MANAGE BRANDS
    GuideButtonType["MANAGE_BRANDS_LIST"] = "MANAGE_BRANDS_LIST";
    GuideButtonType["ADD_BRANDS"] = "ADD_BRANDS";
    GuideButtonType["EDIT_BRANDS"] = "EDIT_BRANDS";
    // BRAND ASSETS
    GuideButtonType["FONTS"] = "FONTS";
    GuideButtonType["EMAIL"] = "EMAIL";
    GuideButtonType["TIME_ZONE"] = "TIME_ZONE";
    GuideButtonType["API_ACCESS_KEY"] = "API_ACCESS_KEY";
    GuideButtonType["BRAND_TERMS"] = "BRAND_TERMS";
    GuideButtonType["FORM_PARAMETERS"] = "FORM_PARAMETERS";
    // WEBHOOK
    GuideButtonType["WEBHOOK_DASHBOARD"] = "WEBHOOK_DASHBOARD";
    GuideButtonType["WEBHOOK_ANALYTICS"] = "WEBHOOK_ANALYTICS";
    GuideButtonType["WEBHOOK_CREATE"] = "WEBHOOK_CREATE";
    GuideButtonType["WEBHOOK_EDIT"] = "WEBHOOK_EDIT";
    //RECEIPTS
    GuideButtonType["RECEIPT_DASHBOARD"] = "RECEIPT_DASHBOARD";
    GuideButtonType["RECEIPT_SETTINGS"] = "RECEIPT_SETTINGS";
    GuideButtonType["UPLOADED_RECEIPT"] = "UPLOADED_RECEIPT";
    GuideButtonType["RECEIPT_ANALYTICS"] = "RECEIPT_ANALYTICS";
})(GuideButtonType || (exports.GuideButtonType = GuideButtonType = {}));
